import { validator } from "@/utils/validator";

export const jobTypeSchema = validator.object().shape({
  jobName: validator.string().trim().emptyToNull().label("作業").required(),
});

export const masterDataCreateMajorSchema = validator.object().shape({
  majorName: validator.string().trim().emptyToNull().label("職種").required(),
  jobTypes: validator.array().of(jobTypeSchema).label("occupations").required(),
});

export const masterDataUpdateMajorSchema = validator.object().shape({
  majorName: validator.string().trim().emptyToNull().label("職種").required(),
});
